/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ScreenerBedUnit } from './ScreenerBedUnit';
import {
    ScreenerBedUnitFromJSON,
    ScreenerBedUnitFromJSONTyped,
    ScreenerBedUnitToJSON,
    ScreenerBedUnitToJSONTyped,
} from './ScreenerBedUnit';

/**
 * 
 * @export
 * @interface FindAllScreenerBedUnits200Response
 */
export interface FindAllScreenerBedUnits200Response {
    /**
     * 
     */
    data?: Array<ScreenerBedUnit>;
}

/**
 * Check if a given object implements the FindAllScreenerBedUnits200Response interface.
 */
export function instanceOfFindAllScreenerBedUnits200Response(value: object): value is FindAllScreenerBedUnits200Response {
    return true;
}

export function FindAllScreenerBedUnits200ResponseFromJSON(json: any): FindAllScreenerBedUnits200Response {
    return FindAllScreenerBedUnits200ResponseFromJSONTyped(json, false);
}

export function FindAllScreenerBedUnits200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllScreenerBedUnits200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(ScreenerBedUnitFromJSON)),
    };
}

export function FindAllScreenerBedUnits200ResponseToJSON(json: any): FindAllScreenerBedUnits200Response {
    return FindAllScreenerBedUnits200ResponseToJSONTyped(json, false);
}

export function FindAllScreenerBedUnits200ResponseToJSONTyped(value?: FindAllScreenerBedUnits200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(ScreenerBedUnitToJSON)),
    };
}

